import {Injectable} from '@angular/core';

import {ManualList, ManualListElement, ModuleType} from "../../models";
import {SubtitlesService} from "../subtitles.service";
import {ParametersService} from "../parameters.service";

@Injectable({
    providedIn: 'root'
})
export class ManualsService {
    private manualsList: ManualList = {
        pl: {
            default: [
                {
                    filename: 'google_Home_for_eModul_PL.pdf',
                    title: 'Instrukcja Google Home dla eModule',
                }
            ]
        },
        en: {
            default: [
                {
                    filename: 'google_Home_for_eModul_EN.pdf',
                    title: 'Google Home Setup Instructions – eModul',
                },
                {
                    filename: 'alexa_instructions_emodul_smart.pdf',
                    title: 'Alexa Instructions eModul Smart',
                },
            ],
            polypipe: [
                {
                    filename: 'google_assistant_smart_plus_instructions.pdf',
                    title: 'Google Assistant Smart Plus Instructions',
                },
                {
                    filename: 'alexa_instructions_smart_plus.pdf',
                    title: 'Alexa Instructions Smart Plus',
                },
                {
                    filename: 'EN_UFH8ZMP_2018.06.08.pdf',
                    title: 'UTFH8ZMP',
                },
                {
                    filename: 'EN_UFHINTWIFIP_2018.05.15.pdf',
                    title: 'UFHINTWIFIP',
                },
                {
                    filename: 'EN_UFHTFTMBP_UFHTFTMWP_M-8_2018.05.30.pdf',
                    title: 'UFHTFT',
                },
                {
                    filename: 'EN_UFHTFTMBP_UFHTFTMWP_M-8_2018.05.30.pdf',
                    title: 'UFHTFTM',
                },
            ],
            roth: [
                {
                    filename: 'Google_Home_for_Touchline_SL_A5_UK_20221222_til_app.pdf',
                    title: 'Google Home for Touchline SL',
                },
                {
                    filename: 'Roth_Touchline_SL_app_user_manual_UK_20221222_til_app.pdf',
                    title: 'Roth Touchline SL app user manual',
                },
            ]
        }
    };
    list: ManualListElement[] = [];
    path: string = '';


    constructor(
        private subtitles: SubtitlesService,
        private parameters: ParametersService,
    ) {
    }

    getManualsList(moduleType?: ModuleType): void {
        this.path = '/public/docs/' + this.getLanguage();
        this.list = [];
        const language = this.getLanguage();
        const company = this.parameters.urlCompany;
        const hasCompanyManuals = this.manualsList[language].hasOwnProperty(company);

        if (company.length && hasCompanyManuals) {
            this.list = this.manualsList[language][company];
            return;
        }

        const selectedModuleType = moduleType || this.parameters.selectedModuleType;
        if (selectedModuleType === 'zones_controller') {
            this.list = this.manualsList[language].default;
        }
    }

    private getLanguage(): string {
        return this.manualsList.hasOwnProperty(this.subtitles.language) ? this.subtitles.language : 'en';
    }
}
